// extracted by mini-css-extract-plugin
export default {"container":"messages-list_container__AC9mN","label":"messages-list_label__sW50Q","messagesList":"messages-list_messagesList__MQNxR","loader":"messages-list_loader__48x7g"};